import Vue from 'vue'
import { $$ } from '../_utils'

Vue.component('vue-accordion', {
  template: '#vue-accordion-template',
  props: ['items', 'breakpoint', 'desktop_hidden', 'trigger_on_desktop'],
})

const accordions = $$('#vue-accordion-wrapper')
window.addEventListener('DOMContentLoaded', () => {
  if (!accordions) return
  accordions.forEach(element => {
    new Vue({
      el: element,
    })
  })
})
